const TokenKey = 'auth_token';

export const getToken = () => localStorage.getItem(TokenKey);

export const setToken = (token: string) => localStorage.setItem(TokenKey, token);

export const removeToken = () => localStorage.removeItem(TokenKey);

/**记住用户名的key */
const AccountKey = 'user_account';
/**保存用户名 */
export const setUserAccount = function(account:string){
    localStorage.setItem(AccountKey, account)
}
/**获取用户名 */
export const getUserAccount = function():string{
    return localStorage.getItem(AccountKey) as string
}
/**删除用户名 */
export const removeUserAccount = function(){
    localStorage.removeItem(AccountKey);
}


const PrintDataKey = 'print_data_token';
/**保存用户名 */
export const setPrintData = function(data:any){
    const str = JSON.stringify(data)
    localStorage.setItem(PrintDataKey, str)
}
/**获取打印数据 */
export const getPrintData = function():any{
    const str = localStorage.getItem(PrintDataKey) as string
    return JSON.parse(str)
}

/**删除用户名 */
export const removePrintData = function(){
    localStorage.removeItem(PrintDataKey);
}